//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin: 45px 75px;
`;
export const ListInactivity = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 10px;
    overflow-y: scroll;
    max-height: 420px;
    padding: 0 10px;
    ::-webkit-scrollbar {
        width: 6px;
        @media (min-width: 700px) {
            width: 7px;
        }
    }
`;
export const ListItemInactivity = styled.li`
    width: 365px;
    & header {
        display: flex;
        justify-content: space-between;
        background-color: var(--light-blue-2);
        border-radius: 8px;
        padding: 15px;
        & h3 {
            margin: 0;
            font-size: 16px;
        }
    }
    & div[data-role="time-item-content"] {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px;
        font-size: 13px;
        color: var(--light-gray-5);
        & svg {
            width: 15px;
            fill: var(--dark-4);
        }
        & > span:first-child {
            display: grid;
            place-items: center;
        }
    }
`;